import React, { useRef } from "react";
import { useSelector } from "react-redux";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import { LogicRules, ServiceRow } from "./NewLogicModal";
import { RootStateServiceLogicBuilder } from "../../store/service-logic-builder-slice";
import RulesPreview from "./RulesPreview";
import ScrollableWrapper from "../common/ScrollableWrapper";
import ServiceSelection from "../common/ServiceSelection";
import { validateServiceSelection } from "../common/serviceValidation";

interface LogicBuilderStep2Props {
  rules: LogicRules;
  serviceRows: ServiceRow[];
  setServiceRows: React.Dispatch<React.SetStateAction<ServiceRow[]>>;
  savedLabPanels?: any[];
}

const LogicBuilderStep2 = ({
  rules,
  serviceRows,
  setServiceRows,
  savedLabPanels,
}: LogicBuilderStep2Props) => {
  const theme: Theme = useTheme();
  const scrollableRef = useRef<HTMLDivElement>(null);
  const savedServices = useSelector(
    (state: RootStateServiceLogicBuilder) =>
      state.serviceLogicBuilder.savedServices
  );

  return (
    <div style={styles.mainContainer}>
      <div style={styles.headerSection}>
        <div style={styles.title(theme)}>Define Service Outcomes</div>
        <div style={styles.text(theme)}>
          Select which services should be provided as outcomes for each rule
          from your services.
        </div>
      </div>
      <div style={styles.contentWithScroll}>
        <ScrollableWrapper ref={scrollableRef}>
          <div style={styles.scrollableContent}>
            <RulesPreview rules={rules} />
            <ServiceSelection
              serviceRows={serviceRows}
              setServiceRows={setServiceRows}
              savedServices={savedServices}
              savedLabPanels={savedLabPanels}
            />
          </div>
        </ScrollableWrapper>
      </div>
    </div>
  );
};

export default LogicBuilderStep2;

// Re-export validation function for backward compatibility
export const validateStep2 = validateServiceSelection;

const styles = {
  mainContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column" as "column",
    minHeight: 0,
    maxHeight: "100%",
    overflow: "hidden",
  },
  headerSection: {
    marginBottom: "16px",
  },
  contentWithScroll: {
    flex: 1,
    display: "flex",
    flexDirection: "column" as "column",
    minHeight: 0,
    maxHeight: "100%",
    overflow: "hidden",
  },
  scrollableContent: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "24px",
    paddingBottom: "20px",
  },
  title: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
  text: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    lineHeight: "17px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    marginTop: "4px",
  }),
};
